var map = {
	"./gallery_00.jpg": 1992,
	"./gallery_01.jpg": 1993,
	"./gallery_02.jpg": 1994,
	"./gallery_03.jpg": 1995,
	"./gallery_04.jpg": 1996,
	"./gallery_05.jpg": 1997,
	"./gallery_06.jpg": 1998,
	"./gallery_07.jpg": 1999,
	"./gallery_08.jpg": 2000,
	"./gallery_09.jpg": 2001
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1991;